<template>
  <BaseCombobox
    class="nutrient-combobox"
    :model-value="modelValue"
    :items="items"
    :label-key="labelKey"
    :value-key="valueKey"
    :group-key="groupKey"
    :placeholder="placeholder"
    :disabled="disabled"
    :exclude-values="excludeValues"
    :aria-label="ariaLabel"
    :has-error="hasError"
    no-results-text="No matching nutrients found"
    :search-keys="[labelKey]"
    input-class="is-small"
    fuzzy-search
    select-exact-match-on-blur
    clear-invalid-input-on-blur
    id-prefix="nutrient-dropdown"
    @update:model-value="emit('update:modelValue', $event)"
    @select="handleSelect"
    @clear="handleClear"
    @invalid-input="emit('invalid-input', $event)"
  >
    <template #option="{ option, selected }">
      {{ option[labelKey] }}
      <span v-if="selected" class="icon is-small has-text-success ml-2">
        <i class="fas fa-check"></i>
      </span>
    </template>
  </BaseCombobox>
</template>

<script setup>
  import { computed, inject } from "vue";

  import BaseCombobox from "../shared/base-combobox.vue";
  import { useSupplementLabelStore } from "../stores/supplement-label-store";

  const triggerSave = inject("triggerSave");
  const store = useSupplementLabelStore();

  const props = defineProps({
    modelValue: { type: String, default: "" },
    labelKey: { type: String, default: "label" },
    valueKey: { type: String, default: "value" },
    groupKey: { type: String, default: "group" },
    placeholder: { type: String, default: "Search nutrients..." },
    disabled: { type: Boolean, default: false },
    excludeValues: { type: Array, default: () => [] },
    ariaLabel: { type: String, default: "Nutrients" },
    hasError: { type: Boolean, default: false },
  });

  const emit = defineEmits(["update:modelValue", "select", "clear", "invalid-input"]);

  const items = computed(() => store.fdaNutrientOptions);

  function handleSelect(option) {
    emit("select", option);
    triggerSave?.();
  }

  function handleClear() {
    emit("clear");
    if (props.modelValue) {
      triggerSave?.();
    }
  }
</script>

<style lang="scss" scoped>
  .nutrient-combobox {
    width: 100%;
  }
</style>
